import { Injectable } from '@angular/core';
import { UserSettingsService } from '@nx-fe/services';
import { map, switchMap, tap } from 'rxjs';
import { MapStyle } from '../../../models';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as mapStyleActions from './map-style.actions';

@Injectable()
export class MapStyleEffects {
  private _defaultMapStyle = MapStyle.NIGHT;

  constructor(private _actions$: Actions, private _userSettings: UserSettingsService) {}

  public updateMapStyle$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(mapStyleActions.updateMapStyle),
        tap(action => this._userSettings.setUserPreferences('mapStyle', action.mapStyle))
      ),
    { dispatch: false }
  );

  public fetchMapStyle$ = createEffect(() =>
    this._actions$.pipe(
      ofType(mapStyleActions.fetchMapStyle),
      switchMap(() =>
        this._userSettings
          .getUserPreferences('mapStyle')
          .pipe(
            map((mapStyle: MapStyle) => mapStyleActions.updateMapStyle({ mapStyle: mapStyle ?? this._defaultMapStyle }))
          )
      )
    )
  );
}
